module.exports = __webpack_public_path__ + "img/banner2.3688b36e.png";